var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.00029C12.5001 5.10415 12.4678 5.20546 12.4076 5.29013C12.3475 5.3748 12.2625 5.43865 12.1644 5.47279L1 9.35592V12.0003C1 12.1329 0.947322 12.2601 0.853553 12.3538C0.759785 12.4476 0.632608 12.5003 0.5 12.5003C0.367392 12.5003 0.240215 12.4476 0.146447 12.3538C0.0526786 12.2601 8.50115e-08 12.1329 8.50115e-08 12.0003V1.00029C-4.64501e-05 0.920482 0.0190126 0.841821 0.055584 0.770883C0.0921555 0.699946 0.145177 0.638794 0.210215 0.592539C0.275254 0.546283 0.350421 0.516269 0.429432 0.505005C0.508442 0.493741 0.589002 0.501554 0.664375 0.527791L12.1644 4.52779C12.2625 4.56194 12.3475 4.62578 12.4076 4.71045C12.4678 4.79513 12.5001 4.89643 12.5 5.00029Z",
    fill: "#C72D22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleFlag);
export default __webpack_public_path__ + "static/media/TriangleFlag.effec4f2c52271a4390b4d570779b9b1.svg";
export { ForwardRef as ReactComponent };